import { render, staticRenderFns } from "./CodigosPrefacturasPreview.vue?vue&type=template&id=8865115c"
import script from "./CodigosPrefacturasPreview.vue?vue&type=script&lang=js"
export * from "./CodigosPrefacturasPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports